export var getTitle = function getTitle() {
  var ogTag = document.querySelector("meta[property='og:title']");
  if (ogTag) return encodeURIComponent(ogTag.getAttribute('content'));
  return encodeURIComponent(document.title);
};
export var getHref = function getHref() {
  return encodeURIComponent(window.location.href);
};